export const environment = {
    production: false,
    company: {code: '0001', name: 'KBC'},     // default company
    language: {name: 'English', code: 'en'},  // default language
    API_BASE_URL : 'https://devendpoints.dzi.bg',
    FE_BASE_URL : 'https://dzi-sit-fe-alb-1290895003.eu-central-1.elb.amazonaws.com',
    API_URL: '/api/v1/',
    EPAY_URL: 'https://devep2.datamax.bg/ep2/epay2_demo/',
    RECAPTCHA_V3_SITEKEY: '6Lf_uicbAAAAAMJ31w1t3uschBC6A4tIdIzN812s',
}
